import {Model} from 'common'
Model.define('model.templateRelation', {
  proxy: {
    get: '/cpu-supplymgr/greenChannel/selectById',
    post: '/cpu-supplymgr/templateAllot/batchInsert'
  },
  meta: {
    id: '',
    objectId: '', // 被分配实体id
    objectName: '', // 实体名
    objectCode: '', // 编码
    objectInnercode: '',
    objectType: '', // 枚举 区分实体 TemplateRelationObjectTypeEnum
    templateId: '', // 认证原因
    templateType: '', // 模板类型 1资质审核认证 2产品试验 3现场认证 4指标评价 5合同
    templateName: '', // 模板名
    templateDescription: '', // 模板描述
    templateClassId: '', // 模板所属分类id
    templateClassName: '', // 模板所属分类名
    alloterId: '', // 分配人id
    alloterName: '', // 分配人名
    allotDate: '', // 分配时间
    isGlobal: '', // 是否全局（集团级）模板 Y N
    allotOrgId: '', // 分配组织id
    allotOrgName: '', // 分配组织名
    ts: '', // ts
    version: '', // version
    level: '', // 升高降低
    changeContent: '', // 变更内容
    isCertification: '' // 是否认证模板 1 认证 0评价
  }
})

export default Model.create('model.templateRelation')



// WEBPACK FOOTER //
// ./src/data/model/templateRelation/index.js